<template>
  <AreaSolutions />
</template>

<script setup lang="ts">
  interface IResponse {
    redirectUrl: string | null;
  }

  definePageMeta({
    pageTransition: false,
    middleware: [
      async (to) => {
        const { $i18n, $customFetch } = useNuxtApp();
        const { locale } = $i18n;
        const { solution, generic } = to.params;

        const solutionAlias = generic ? `${solution}/${generic}` : solution;

        try {
          const data = await $customFetch<IResponse>(
            `/marketplace/api/v1/pages/redirect?websiteCode=${locale.value}&urlAlias=${solutionAlias}&pageType=2`
          );

          if (data.redirectUrl && data.redirectUrl !== to.path) {
            return navigateTo(data.redirectUrl, { redirectCode: 301 });
          }
        } catch (error) {
          console.log(error);
        }
      },
    ],
  });
</script>
